import { RecoilRoot } from 'recoil';
import { Main } from './components/Main';
import styled from 'styled-components';
import { FacebookLike } from './components/common/facebook'
import React from 'react';

import { useRecoilState } from 'recoil';
import { gameProgressState } from './state';


const StyledApp = styled.div`
  background-image: url('img/Leopard-cat-bg.jpg');
  background-position:center;
  background-blend-mode: multiply;
  position: fixed;
  top:0;
  bottom:0;
  left:0;
  right:0;
  background-repeat:repeat;
  background-size: cover;
  ${({ gameProgress }) => {
    if (gameProgress === 'intro') {
      return 'background-color: rgba(0, 0, 0, 0.5);';
    } else {
      return 'background-color: rgba(0, 0, 0, 0);';
    }
  }}
  display: flex;
  flex-direction: column;
  align-items: start;
  padding: 0;
  overflow: auto;
`;

const StyledHeader = styled.div`
background-color:tranparent;
align-content: space-between;
width: 100%;
top:0;
position: fixed;
z-index: 10;
`;
const StyledFb = styled.div`
align-self: flex-end;
padding: 5px 0px;
position: fixed;
right:10px;
top:10px;
z-index: 10;
`;

const StyledShareButton = styled.div`
padding: 5px 0px;
position: fixed;
right:10px;
top:10px;
z-index: 10;
${({ gameProgress }) => {
  if (gameProgress === 'home' || gameProgress === 'result'|| gameProgress === 'intro') {
    return 'display:none;';
  } else {
    return '';
  }
}}
margin: 20px 10px;

@media only screen and (max-width: 600px) {
  max-width:30%;
  ${({ gameProgress }) => {
    if (gameProgress === 'main' || gameProgress === 'intro') {
      return 'display:none;';
    } else
    {
      return '';
    }
  }}
}
`
const ShareButton = styled.img`
max-height: 50px;
padding:3px;
@media only screen and (max-width: 600px) {
  max-width:92%;
  
}
`

const AppBase = () => {
  const [gameProgress] = useRecoilState(gameProgressState);
  return (
    <StyledApp gameProgress={gameProgress}>
      <Header />
      <Main />
    </StyledApp>
  );
}

const App = () => {
  return (
    <RecoilRoot>
      <AppBase />
    </RecoilRoot>
  );
}

const Header = () => {
  const [gameProgress] = useRecoilState(gameProgressState);
  return (
    <>
    <StyledHeader>
      <HrtLogo />
      <StyledShareButton gameProgress={gameProgress}>
            <a href="https://www.facebook.com/2016homeruntaiwan" target="_blank"><ShareButton src={'img/share_fb.png'} /></a>
            <a href="https://www.instagram.com/homerun.taiwan/" target="_blank"><ShareButton src={'img/share_ig.png'} /></a>
          </StyledShareButton>
    </StyledHeader>
    </>
  )
};

const HrtLogo = () => {
return (
  <img src="img/hrtlogo.png" className="hrt-logo" alt='hrt-logo' />
)
};

export default App;
